export default "/assets/images/the-home-wrecker.841ae117cd6c1ff7.webp";